import fetch from '@/utils/fetch'

export function getSubmitProblemList (isUsed) {
  return fetch({
    url: '/get_submit_problem_list',
    params: {
      isUsed
    },
    method: 'get'
  })
}

export function getSubmitProblemByGuid (guid) {
  return fetch({
    url: '/get_submit_problem_by_guid',
    params: {
      guid
    },
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_prepareProblemUser.js